import React from 'react';
import * as S from './style';
import { FormStatusInfo, Label } from 'components';
import { ReactComponent as ImgInterviewNoApprove } from 'assets/img/status/img_interview_no_approve.svg';

interface Props {
  interviewNoApproveDate: string;
  leftDueDate: string;
}

function InterviewNoApprove({
  interviewNoApproveDate,
  leftDueDate,
}: Props): React.ReactElement {
  return (
    <FormStatusInfo
      subTitle={['인터뷰 심사가', '비승인되었습니다.']}
      image={<ImgInterviewNoApprove />}
      btnWidth={180}
      inHomeBtn={true}
    >
      <S.LabelWrapper>
        <Label
          contents={'재신청가능일'}
          color={'gray_opacity_600'}
          fontStyle={'subtitle'}
        />
        <Label
          contents={leftDueDate}
          color={'gray_opacity_800'}
          fontStyle={'body2'}
        />
      </S.LabelWrapper>
      <S.CaptionWrapper>
        안녕하십니까. 짐싸파트너 입니다.
        <br />
        이번 짐싸 파트너 모집에 기다려주시고, 참여해주셔서 진심으로
        감사드립니다.
        <br />
        기사님의 뛰어난 역량에도 불구하고, 아쉽지만 이번 지원에는 함께 할 수
        없게 되었습니다. 뜻밖의 결과에 실망이 크시리라 생각되지만, 본 결과는
        역량 순이 아니라, 짐싸 파트너의 인재상과 조금 다른 부분에 대한 판단의
        결과이오니, 양해부탁드립니다.
        <br /> 일하기 좋은 세상을 만들 수 있도록 노력하는 짐싸가 되겠습니다.
        다시한번 지원해주셔서 고개 숙여 감사드립니다.
        <br />
        <br />
        비승인 이후 90일 동안 신규회원가입이 불가능하며, 90일 이후에는
        해당정보는 모두 삭제될 예정입니다.
        <br />
        <br />
        감사합니다.
      </S.CaptionWrapper>
      <S.DateWrapper>
        <Label
          contents={'비승인 고지일'}
          color={'gray_opacity_600'}
          fontStyle={'body2'}
        />
        <Label
          contents={interviewNoApproveDate}
          color={'gray_opacity_800'}
          fontStyle={'body1'}
        />
      </S.DateWrapper>
      <S.DateWrapper>
        <Label
          contents={'탈퇴 예정일'}
          color={'gray_opacity_600'}
          fontStyle={'body2'}
        />
        <Label
          contents={leftDueDate}
          color={'gray_opacity_800'}
          fontStyle={'body1'}
        />
      </S.DateWrapper>
    </FormStatusInfo>
  );
}

export default InterviewNoApprove;
